
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { LineChartIcon, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import LineChartDisplay from "../charts/LineChartDisplay";

interface VoorraadTabProps {
  inventoryData: any[];
  inventoryTrendData: any[];
}

const VoorraadTab: React.FC<VoorraadTabProps> = ({
  inventoryData,
  inventoryTrendData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Voorraadstatus</CardTitle>
            <CardDescription>Status van voorraaditems</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={inventoryData} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Voorraadtrend</CardTitle>
            <CardDescription>Voorraadniveaus over tijd</CardDescription>
          </div>
          <LineChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <LineChartDisplay
            data={inventoryTrendData}
            dataKey="voorraad"
            nameKey="month"
            lineName="Voorraadniveau"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default VoorraadTab;
